import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CalendarBlank,
  House,
  MagnifyingGlass,
  Users,
} from '@thinkific/chalk/react-icons';
import {
  goToAllSpaces,
  goToEvents,
  goToHome,
  goToSearch,
} from 'utils/routerHelpers';
import { useRouter } from 'next/router';
import { MobileTabNav } from '@thinkific/chalk/recipes/MobileTabNav';
import TrackingEvent, { TrackingProperty } from 'constants/trackingEvents';
import { useCommunityContext } from 'components/CommunityContext';
import * as css from './MobileChin.css';

interface MobileChinProps {
  community: {
    name: string;
    id: string;
  };
}

export const MobileChin = ({ community }: MobileChinProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { trackEvent } = useCommunityContext();

  const tabs = [
    {
      id: 'home',
      label: t('communities_pages-home_title', 'Home'),
      icon: House,
      href: `/communities/${community.id}/`,
      onClick: (e) => {
        e.preventDefault();
        trackEvent(TrackingEvent.GO_TO_HOME, {
          [TrackingProperty.COMPONENT]: 'MobileNav',
        });
        goToHome(router, community.id);
      },
    },
    {
      id: 'spaces',
      label: t('communities_pages-spaces_title', 'Spaces'),
      icon: Users,
      href: `/communities/${community.id}/spaces`,
      onClick: (e) => {
        e.preventDefault();
        trackEvent(TrackingEvent.GO_TO_SPACES, {
          [TrackingProperty.COMPONENT]: 'MobileNav',
        });
        goToAllSpaces(router, community.id);
      },
    },
    {
      id: 'events',
      label: t('communities_pages-events_title', 'Events'),
      icon: CalendarBlank,
      href: `/communities/${community.id}/events`,
      onClick: (e) => {
        e.preventDefault();
        trackEvent(TrackingEvent.CLICK_SEE_ALL_EVENTS, {
          [TrackingProperty.COMPONENT]: 'MobileNav',
        });
        goToEvents(router, community.id);
      },
    },
    {
      id: 'search',
      label: t('communities_pages-search_title', 'Search'),
      icon: MagnifyingGlass,
      href: `/communities/${community.id}/search`,
      onClick: (e) => {
        e.preventDefault();
        trackEvent(TrackingEvent.GO_TO_SEARCH, {
          [TrackingProperty.COMPONENT]: 'MobileNav',
        });
        goToSearch(router, community.id);
      },
    },
  ];

  return (
    <div className={css.container} data-qa="mobile-chin">
      <MobileTabNav
        currentTabId={
          tabs.find((tab) => router.route.includes(tab.id))?.id || 'home'
        }
        tabs={tabs}
      />
    </div>
  );
};

export default MobileChin;
